import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { RutDirective } from 'src/app/directives/rut.directive';
import {
  GetTravelersAPI,
  PostCreateTravelersAPI,
  PostUpdateTravelersAPI,
} from 'src/app/models';
import { RutPipe } from 'src/app/pipes/rut.pipe';
import { customValidatorRut } from 'src/app/utils/validators';
import Swal from 'sweetalert2';
import { GeneralService } from '../../services/general.service';
import { SeoService } from '../../services/seo.service';
import { SesionService } from '../../services/sesion.service';
import { WebServicesService } from '../../services/web-services.service';

@Component({
  selector: 'app-crear-pasajeros',
  templateUrl: './crear-pasajeros.component.html',
  styleUrls: ['./crear-pasajeros.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    RutDirective,
    TranslateModule,
  ],
  providers: [
    FormBuilder,
    WebServicesService,
    SesionService,
    GeneralService,
    SeoService,
    NgbModal,
    RutPipe,
  ],
})
export class CrearPasajerosComponent implements OnInit {
  @Input() modal: Boolean = false;
  @Input() edit: Boolean = false;
  @Input() obj: any;
  @Output() eventEmit = new EventEmitter<any>();
  form: FormGroup;
  @Output() eventClose = new EventEmitter<any>();
  maskText: string = '00.000.000-A||0.000.000-A';
  parentName: any =
    '^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+(s*[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+$';
  parentPhone: any = '^[0-9]+$';
  cities: any = [];
  countries: any = [];
  err: any;

  names: any = [];
  properties: any = [];
  changeCity = false;

  private _fb = inject(FormBuilder);
  private _ws = inject(WebServicesService);
  private _sesion = inject(SesionService);
  private _router = inject(Router);
  private _activateRoute = inject(ActivatedRoute);
  private _tool = inject(GeneralService);
  private _titleBrowser = inject(Title);
  private _modalService = inject(NgbModal);
  private _seo = inject(SeoService);
  private _rutPipe = inject(RutPipe);

  constructor() {
    this._sesion.userSubject.asObservable().subscribe((user) => {
      this._sesion.user = user;
    });
    this._ws.newComplemt = this._activateRoute.snapshot.params.complement
      ? this._activateRoute.snapshot.params.complement
      : 'pasajes';
  }

  ngOnInit(): void {
    let id;
    this._activateRoute.params.subscribe((params) => {
      id = params['id'];
      if (id) {
        this.edit = true;
        this.getTravelers(id);
      } else {
        if (this.obj) {
          this.edit = true;
          this.getTravelers(this.obj.id);
        } else {
          this.edit = false;
        }
      }
    });
    this.initializeForms();
    this.initializeSEO();
  }

  ngAfterViewInit() {
    if (this.cities.length === 0) {
      let cities = this._sesion.getCities(this._ws.newComplemt);
      if (!cities) {
        this.getCities();
      } else {
        setTimeout(() => {
          this.cities = cities;
        }, 10);
      }
    }
  }

  loadData() {
    if (this.obj) {
      this.form.controls['typeDocument'].setValue(
        this.obj.typerutpassport == 'RUT' ? '1' : '2'
      );
      this.form.controls['rut'].setValue(
        this._rutPipe.transform(this.obj.rut, this.obj.typerutpassport)
      );
      this.form.controls['firstname'].setValue(this.obj.firstname);
      this.form.controls['lastname'].setValue(this.obj.lastname);
      this.form.controls['email'].setValue(this.obj.email);
      this.form.controls['phone'].setValue(this.obj.phone);
      this.form.controls['city'].setValue(this.obj.city);
      this.form.controls['nationalidad'].setValue(this.obj.country);

      // remove customValidatorRut if typeDocument is 2
      if (this.obj.typerutpassport == 'PASAPORTE') {
        this.form.controls['rut'].clearValidators();
        this.form.controls['rut'].setValidators([Validators.required]);
        this.form.controls['rut'].updateValueAndValidity();
      }

      if (this.edit) {
        this.searchNationality(this.obj.country);
        this.searchCity(this.obj.city);
      }
    }
  }


  initializeForms() {
    this.form = this._fb.group({
      typeDocument: ['1'],
      rut: [
        '',
        [
          Validators.minLength(8),
          Validators.maxLength(12),
          Validators.required,
          customValidatorRut(),
        ],
      ],
      firstname: [
        '',
        [Validators.required, Validators.pattern(this.parentName)],
      ],
      lastname: [
        '',
        [Validators.required, Validators.pattern(this.parentName)],
      ],
      email: ['', [Validators.required, Validators.email]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(this.parentPhone),
          Validators.minLength(9),
          Validators.maxLength(9),
        ],
      ],
      city: [null, [Validators.required]],
      nationalidad: [null, [Validators.required]],
    });

    this.countries = this._tool.getCountries();

    if (this.edit) {
      this.loadData();
    }
  }

  formatRut() {
    let value = this.form.get('rut').value.replace(/[.-]/g, '');
    // value = value.split(".").join("");
    // if (value.indexOf("-") == -1) {
    //   value = value.slice(0, value.length - 1) + "-" + value.slice(length - 1);
    // }
    return value;
  }

  getTravelers(id: any) {
    if (this._sesion.user && this._sesion.user.id) {
      this._ws
        .selectType('travelers_get', {
          accesstoken: this._sesion.getAccessToken(),
        })
        .then(
          (res) => {
            const data: GetTravelersAPI.ApiResponse = JSON.parse(res as string);

            if (data.success === true) {
              let travelers = data.response.travelers;
              let traveler = travelers.find((tr: any) => {
                return tr.id == id;
              });

              if (traveler) {
                this.obj = traveler;
                this.searchCity(this.obj.city);
                this.loadData();
              }
            }
          },
          (err) => {
            console.error(err);
          }
        );
    }
  }
  cambiarCiudad() {
    this.changeCity = true;
  }

  save() {
    if (this.form.valid) {
      let endpoint = 'travelers_create';
      let params: Record<string, string> = {
        typerutpassport:
          this.form.value.typeDocument == '1' ? 'RUT' : 'PASAPORTE',
        rut:
          this.form.value.typeDocument == '1'
            ? this.formatRut()
            : this.form.value.rut,
        firstname: this.form.value.firstname,
        lastname: this.form.value.lastname,
        email: this.form.value.email,
        country: this.form.value.nationalidad['code'],
        phone: this.form.value.phone,
        city: this.form.value.city['city'],
        accesstoken: this._sesion.getAccessToken(),
      };

      if (params.city == undefined) {
        params.city = this.form.value.city;
      }

      if (this._sesion.getAccessToken()) {
        if (this.edit) {
          params.passengerid = this.obj.id;
          endpoint = 'travelers_put';
        }

        this._ws.selectType(endpoint, params).then(
          (res) => {
            const data = JSON.parse(res as string) as
              | PostCreateTravelersAPI.ApiResponse
              | PostUpdateTravelersAPI.ApiResponse;

            if (data.success === true) {
              if (!this.edit) {
                this.form.reset();
                this.form.controls['typeDocument'].setValue('1');
              }

              Swal.fire({
                title: `Pasajero ${
                  this.edit ? 'modificado' : 'creado'
                } con éxito`,
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: 'var(--primary)',
                confirmButtonText: 'Ok',
              });
              this._modalService.dismissAll();
              this.emit();
              this.emitLoad();
            }
            if (data.success === false) {
              Swal.fire({
                title: `${data.response}`,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: 'var(--primary)',
                confirmButtonText: 'Ok',
              }).then(() => {
                this.emit();
              });
              this.err = `Error ${data.number_error} - ${data.response}`;
              // this.tool.showAlert(`Error ${info[0].number_error}`, info[0].error);
            }
          },
          (err) => {}
        );
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  searchCity(search: any) {
    for (const elem of this.cities) {
      if (search == elem.city) {
        this.form.controls['city'].setValue(elem);
        break;
      }
    }
  }

  searchNationality(search) {
    for (const elem of this.countries) {
      if (search == elem.code) {
        this.form.controls['nationalidad'].setValue(elem);
        break;
      }
    }
  }

  checkedForm(formGroup: FormGroup) {
    let control: any = null;
    Object.keys(formGroup.controls).forEach((name) => {
      control = formGroup.controls[name].markAsTouched();
    });
  }

  getCities() {
    this._ws.selectType('cities', {}).then(
      (cities) => {
        this.cities = cities;
        this.cities = JSON.parse(this.cities);
        //this.sesion.loadCities(this.cities, this.ws.newComplemt);

        if (this.edit) {
          this.searchCity(this.obj.city);
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  changeTypeDocument(value: number) {
    this.form.get(`typeDocument`).setValue(value);
    if (value == 1) {
      this.form
        .get(`rut`)
        .setValue(this._rutPipe.transform(this.form.get(`rut`).value, 'RUT'));
      this.form.controls[`rut`].setValidators([
        Validators.minLength(8),
        Validators.maxLength(12),
        Validators.required,
        customValidatorRut(),
      ]);
      this.form.controls[`rut`].updateValueAndValidity();
    } else {
      // quitar puntos y guion
      if (this.form.get(`rut`).value && this.form.get(`rut`).value.length > 1) {
        this.form.get(`rut`).setValue(
          this.form
            .get(`rut`)
            .value.replace(/[^0-9kK]+/g, '')
            .replace(/^0+/, '')
            .toUpperCase()
        );
      }
      this.form.controls[`rut`].setValidators([
        Validators.minLength(4),
        Validators.maxLength(20),
        Validators.required,
      ]);
      this.form.controls[`rut`].updateValueAndValidity();
    }
  }

  emitLoad() {
    this.eventEmit.emit(true);
  }

  emit() {
    this.eventClose.emit(false);
  }

  initializeSEO() {
    this.valuesSeo('title');
  }

  valuesSeo(title) {
    this.names = [];
    this.properties = [];
    this.names.push({ key: 'title', value: title });
    // this.names.push({ key: "robots", value: "index,follow" });
    this.names.push({ key: 'twitter:card', value: 'summary_large_image' });
    // this.names.push({key: 'twitter:site', value: '@chilepasajes'});
    this.properties.push({ key: 'og:title', value: 'Title' });
    this.properties.push({ key: 'og:description', value: 'descripcion' });
    this.properties.push({ key: 'og:site_name', value: 'site' });
    this._seo.generateTag(this.names, this.properties);
  }
}
